/* Quarry welcome offer.
   The app popup fired on load, covered the hero and made the nav unclickable.
   This one is intent-driven: it cannot appear before a minimum dwell, and it
   opens only on exit intent, scroll depth, or a dwell timer -- whichever comes
   first. A dismissal is remembered; an actual signup suppresses it for good. */
(function () {
  var el = document.querySelector('[data-qoffer]');
  if (!el) return;

  var KEY = 'if_offer_v1';
  var num = function (k, d) { var v = parseInt(el.dataset[k], 10); return isNaN(v) ? d : v; };
  var MIN_DWELL = num('minDwell', 8) * 1000;
  var DELAY     = num('delay', 30) * 1000;
  var SCROLL    = num('scroll', 45);
  var REMEMBER  = num('rememberDays', 14);
  var EXIT      = el.dataset.exitIntent === 'true';

  function state() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  var s = state();
  if (s.subscribed) return;                                  // never again
  if (s.hideUntil && Date.now() < s.hideUntil) return;        // still dismissed

  var opened = false, armed = false, settled = false, lastFocus = null;
  var panel = el.querySelector('.qoffer__panel');

  function focusable() {
    return [].slice.call(panel.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'
    )).filter(function (n) { return n.offsetWidth || n.offsetHeight; });
  }

  function open() {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    var f = focusable();
    if (f.length) f[0].focus();
    document.addEventListener('keydown', onKey, true);
  }

  function close(remember) {
    if (!opened) return;
    opened = false;
    el.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    var done = function () { el.hidden = true; };
    // wait out the transition unless motion is reduced
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else setTimeout(done, 220);
    settled = true;              // nothing may re-open it in this page view
    teardown();
    if (remember !== false) {
      var o = state(); o.hideUntil = Date.now() + REMEMBER * 864e5; save(o);
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusable(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-qoffer-close]')) { e.preventDefault(); close(); }
  });

  /* A successful signup came back from Shopify: show the code and never ask again. */
  if (window.__quarryOfferPosted) {
    var o = state(); o.subscribed = true; save(o);
    el.querySelector('[data-qoffer-state="form"]').hidden = true;
    el.querySelector('[data-qoffer-state="done"]').hidden = false;
    open();
    return;
  }
  el.addEventListener('submit', function () {
    var o = state(); o.subscribed = true; save(o);
  });

  /* Nothing may fire until the visitor has actually been here a moment. */
  setTimeout(function () { armed = true; }, MIN_DWELL);
  var fire = function () { if (armed && !settled && !opened) open(); };

  var dwellTimer = setTimeout(function () { fire(); }, MIN_DWELL + DELAY);

  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    if ((window.scrollY / h) * 100 >= SCROLL) { window.removeEventListener('scroll', onScroll); fire(); }
  }
  function onExit(e) { if (e.clientY <= 0 && !e.relatedTarget) fire(); }

  function teardown() {
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
    if (dwellTimer) clearTimeout(dwellTimer);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  if (EXIT && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', onExit);
  }
})();
